//Custom components
import StatCard from '../../../UI/Card/StatCard';

const ApprovedApplicationsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Approved Submissions' stat={count} />;
};

export default ApprovedApplicationsWidget;
